// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1uhC2","title":"Images45_title__2pmoG","images":"Images45_images__1kyM-"};